import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Banner } from "@/services/banner.service.ts";

interface SortableItemProps {
  banner: Banner;
}

const SortableItem: React.FC<SortableItemProps> = ({ banner }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: banner.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      {...listeners}
      {...attributes}
      ref={setNodeRef}
      style={style}
      className="relative mb-3 flex w-1/3 items-center gap-2 rounded-lg"
    >
      {/* Drag Handle */}
      <div className="flex cursor-grab items-center justify-center p-2 text-gray-400 hover:text-gray-300">
        <span className="text-3xl">☰</span>
      </div>

      {/* Banner Content */}
      <div className="flex flex-1 items-center justify-center rounded-lg bg-gray-700">
        {banner.desktopUrl ? (
          <img
            src={banner.desktopUrl}
            alt={banner.name}
            className="h-auto w-full rounded-lg object-cover"
          />
        ) : (
          <span className="flex h-24 items-center justify-center text-lg text-gray-400">
            no image
          </span>
        )}
      </div>
    </div>
  );
};

export default SortableItem;
